import { EWorkingType } from '../enums'
import { IOptionItem } from 'interfaces'

export const WORKING_TYPE_OPTIONS: Array<IOptionItem> = [
  {
    label: 'administrative-days',
    value: EWorkingType.AdministrativeDay
  },
  {
    label: 'all-week',
    value: EWorkingType.AllWeek
  },
  {
    label: 'custom',
    value: EWorkingType.Custom
  }
]
